const style = {
  popup: {
    position: "absolute",
    top: "348px",
    left: "583px",
    transform: "translate(-50%, -50%)",
    width: 755,
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "30px",
  },

  buttonStyle: {
    marginTop: "30px",
    backgroundColor: "#043D90",
    color: "#FFFFFF",
    borderRadius: 8,
    width: 230,
    height: 40,
    // marginLeft: "20%",
    // marginBottom: "20%",
  },

  typography: {
    color: "#8C8C8C",
    fontSize: "20px",
  },

  inputStyle: {
    height: 91,
    minWidth: "330",
    maxWidth: "400",
    // border: "1px solid #707070",
    borderRadius: "5px",
  },

  cancelBtn: {
    marginLeft: "40px",
    marginTop: "30px",
    width: "176px",
    height: "40px",
    color: "#043D90",
    border: "1px solid #043D90",
    borderRadius: "8px",
  },

  mediumItem: {
    flex: "1 1 28%",
    paddingLeft: "10px",
  },
};

export default style;
